// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5B0Rp","question":"styles_question__3V59t","inputVisibleButton":"styles_inputVisibleButton__2swt0","note":"styles_note__3Of4m"};